import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { browserHistory } from 'react-router';
// import Moment from 'react-moment';
// import Pagination from "react-js-pagination";
// import * as constant from '../../../constants/constant';
import * as adminDashboardActions from '../../../actions/admin/dashboard/admindashboardActions';
import autoBind from 'auto-bind';
// import ShowMore from 'react-show-more';
// import '../../styles/css/style.css';

class AdminDashboard extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
		}


	}

	// searchText
	componentWillMount() {

	}
	componentWillReceiveProps(nextProps) {

	}

	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let object = {
			page: pageNumber,
			count: this.state.count,
		}
		this.props.actions.getAllBlogList(object);
	}
	onChangeTab() {
		this.setState({ activePage: 1 });
		let object = {
			page: 1,
			count: 10,
		}
		this.props.actions.getAllBlogList(object);
	}
	componentDidMount() {

	}
	render() {

		return (
			<div className="content-wrapper">
				<section className="content container-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB proCalendar">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li ><Link href="#tab_1" data-toggle="tab" className="active show">Admin Dashboard</Link></li>
									</ul>
									<div className="row">
										<div className="col-lg-3 col-xs-6">
											<div className="small-box bg-aqua">
												<div className="inner">
													<h3>150</h3>
													<p>Finance User</p>
												</div>
												<div className="icon">
													<i className="ion ion-bag"></i>
												</div>
												<Link to="/user/financeuser" className="small-box-footer">More info <i className="fa fa-arrow-circle-right"></i></Link>
											</div>
										</div>
										<div className="col-lg-3 col-xs-6">
											<div className="small-box bg-green">
												<div className="inner">
													<h3>53%</h3>

													<p>Feedback User</p>
												</div>
												<div className="icon">
													<i className="ion ion-stats-bars"></i>
												</div>
												<Link to="/user/feedbackuser" className="small-box-footer">More info <i className="fa fa-arrow-circle-right"></i></Link>
											</div>
										</div>
										<div className="col-lg-3 col-xs-6">
											<div className="small-box bg-yellow">
												<div className="inner">
													<h3>44</h3>

													<p>Vetting User</p>
												</div>
												<div className="icon">
													<i className="ion ion-person-add"></i>
												</div>
												<Link to="/user/vettinguser" className="small-box-footer">More info <i className="fa fa-arrow-circle-right"></i></Link>
											</div>
										</div>
										<div className="col-lg-3 col-xs-6">
											<div className="small-box bg-blue">
												<div className="inner">
													<h3>44</h3>

													<p>Specialist Assisstant</p>
												</div>
												<div className="icon">
													<i className="ion ion-person-add"></i>
												</div>
												<Link to="/user/financeuser" className="small-box-footer">More info <i className="fa fa-arrow-circle-right"></i></Link>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-lg-3 col-xs-6">
											<div className="small-box bg-maroon">
												<div className="inner">
													<h3>44</h3>

													<p>Photo User</p>
												</div>
												<div className="icon">
													<i className="ion ion-person-add"></i>
												</div>
												<Link to="/user/photouser" className="small-box-footer">More info <i className="fa fa-arrow-circle-right"></i></Link>
											</div>
										</div>
										<div className="col-lg-3 col-xs-6">
											<div className="small-box bg-red">
												<div className="inner">
													<h3>150</h3>

													<p>Specilaists</p>
												</div>
												<div className="icon">
													<i className="ion ion-bag"></i>
												</div>
												<Link to="/user/specialistuser" className="small-box-footer">More info <i className="fa fa-arrow-circle-right"></i></Link>
											</div>
										</div>
										<div className="col-lg-3 col-xs-6">
											<div className="small-box bg-navy">
												<div className="inner">
													<h3>53%</h3>

													<p>Patients</p>
												</div>
												<div className="icon">
													<i className="ion ion-stats-bars"></i>
												</div>
												<Link to="/user/patients" className="small-box-footer">More info <i className="fa fa-arrow-circle-right"></i></Link>
											</div>
										</div>
										<div className="col-lg-3 col-xs-6">
											<div className="small-box bg-purple">
												<div className="inner">
													<h3>44</h3>

													<p>Appointments</p>
												</div>
												<div className="icon">
													<i className="ion ion-person-add"></i>
												</div>
												<Link to="/user/financeuser" className="small-box-footer">More info <i className="fa fa-arrow-circle-right"></i></Link>
											</div>
										</div>

									</div>
								</div>
							</div>
						</div>

					</div>

				</section>
				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>

		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	// return {
	// };
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(adminDashboardActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard);
